module.exports = __webpack_public_path__ + "img/item7.aaadd2b5.png";